<template>
  <div id="sites">
    <SectionCriar />
    <SectionLista />
    <CriarArea />
  </div>
</template>

<script setup>
import { onMounted, inject } from 'vue'
import { useStorePerfil, useStoreAreas, useStorePainel } from '@stores'
import SectionCriar from '@/components/app/inicio/partials/SectionCriar.vue'
import SectionLista from '@/components/app/inicio/partials/SectionLista.vue'
import CriarArea from '@/components/app/inicio/modals/CriarArea.vue'

const storePerfil = useStorePerfil()
const storeAreas = useStoreAreas()
const storePainel = useStorePainel()
const emitter = inject('emitter')

function carregarPerfil() {
  storePerfil.receberPerfilUsuario()
}

function carregarAreas() {
  storeAreas.receberTodos()
}

function carregarEstatisticas() {
  storePainel.receberEstatisticas()
}

onMounted(() => {
  carregarPerfil()
  carregarAreas()
  carregarEstatisticas()
  emitter.on('atualizarAreas', () => {
    carregarAreas()
    carregarEstatisticas()
  })
})
</script>

<style scoped>
#sites {
  animation: fadeIn 0.3s linear;
  padding: 0 0 0 260px;
}
@media screen and (max-width: 1000px) {
  #sites {
    padding: 0;
  }
}
</style>
